export const getGoogleMapsLink = (address: string) => {
  const encoded = encodeURIComponent(address);

  return `https://www.google.com/maps?q=${encoded}&t=k&z=18`;
};

export const formatAddress = (
  address: Maybe<
    | string
    | {
        street?: string;
        housenr?: string;
        boxnr?: string | null;
        zipcode?: string;
        city?: string;
        country_code?: string;
      }
  >,
): string | undefined => {
  if (!address) return undefined;
  if (typeof address === 'string') return address;

  const parts: string[] = [];

  if (address.street) {
    let streetPart = address.street;
    if (address.housenr) {
      streetPart += ` ${address.housenr}`;
    }
    if (address.boxnr) {
      streetPart += ` ${address.boxnr}`;
    }
    parts.push(streetPart);
  }

  if (address.zipcode || address.city) {
    const cityPart = [address.zipcode, address.city].filter(Boolean).join(' ');
    if (cityPart) parts.push(cityPart);
  }

  return parts.length > 0 ? parts.join(', ') : undefined;
};
